import { CheckCircleFilled } from "@ant-design/icons"
import { Button, Flex, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { brand } from "../../../../components/widgets/tokens.ts"

const { Text, Title } = Typography

interface ReportWizardSuccessProps {
  name: string
  folder: string
  onOpen: () => void
  onBackToReports: () => void
}

/** Shown only once the report was saved and taken out of draft. */
export const ReportWizardSuccess = ({
  name,
  folder,
  onOpen,
  onBackToReports
}: ReportWizardSuccessProps) => {
  const { t } = useTranslation()
  return (
    <Flex
      vertical
      align="center"
      gap="middle"
      role="status"
      className="mx-auto max-w-[560px] py-16 text-center"
    >
      <CheckCircleFilled
        aria-hidden
        style={{ color: brand.teal, fontSize: 56 }}
      />
      <Title level={3} className="m-0 text-start">
        {t("reports.wizard.success.title")}
      </Title>
      <Text type="secondary">
        {folder
          ? t("reports.wizard.success.bodyInFolder", { name, folder })
          : t("reports.wizard.success.body", { name })}
      </Text>
      <Flex gap="small" className="pt-2">
        <Button size="large" onClick={onBackToReports}>
          {t("reports.wizard.success.backToReports")}
        </Button>
        <Button size="large" type="primary" autoFocus onClick={onOpen}>
          {t("reports.wizard.success.open")}
        </Button>
      </Flex>
    </Flex>
  )
}
